module.exports = __webpack_public_path__ + "static/media/cookies.3d377a72.svg";